import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FiEye, FiAlertCircle } from 'react-icons/fi';
import { CustomerCenterService } from "../../../services";
import arrowLeft from '../../../assets/img/icon/arrow-left.svg';
import arrowRight from '../../../assets/img/icon/arrow-right.svg';
import TopSetion from '../../../components/customer-service-center/TopSetion';
import SubHeading from '../../../components/customer-service-center/SubHeading';
import defaultNewsImage from '../../../assets/img/customer-service-center/news-default-img.gif';
import { formatDateToYYYYMMDD } from '../../../utils/dateUtils';

const MemorialNewsDetails = () => {
    const navigate = useNavigate();
    const [memorialNewsDetail, setMemorialNewsDetail] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { id } = useParams();


    const fetchMemorialNewsData = async () => {
        try {
            setLoading(true);
            const response = await CustomerCenterService.getMemorialNewsById(id);

            if (response && response.id) {
                // Ensure previous and next fields are properly set
                response.previous = response.previous || null;
                response.next = response.next || null;

                setMemorialNewsDetail(response);
                setError(null);
            } else {
                setError('추모원 소식을 찾을 수 없습니다.');
            }
        } catch (err) {
            console.error('Failed to fetch memorial news data:', err);
            setError('추모원 소식 데이터를 불러오는데 실패했습니다.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMemorialNewsData();
    }, [id]);

    const handleNavigationClick = (direction) => {
        if (!memorialNewsDetail) return;

        const targetArticle = direction === 'prev' ? memorialNewsDetail.previous : memorialNewsDetail.next;

        if (targetArticle && targetArticle.id) {
            // Set loading state for better UX
            setLoading(true);
            // Navigate to the previous/next article
            navigate(`/memorial-news/${targetArticle.id}`);
        }
    };

    return (
        <>
            <div className="announcement-list-page">

                <TopSetion />


                {/* Main Content */}
                <main className="main-content">
                    <SubHeading heading="추모원 소식" />

                    {/* Announcement Details Section */}
                    {loading ? (
                        <section className="announcement-details-section">
                            <div className="loading-container">
                                <div className="loading-spinner"></div>
                                <p>추모원 소식을 불러오는 중...</p>
                            </div>
                        </section>
                    ) : error ? (
                        <section className="announcement-details-section">
                            <div className="error-container">
                                <FiAlertCircle size={48} className="error-icon" />
                                <p>{error}</p>
                                <button
                                    className="retry-button"
                                    onClick={() => window.location.reload()}
                                >
                                    다시 시도
                                </button>
                            </div>
                        </section>
                    ) : memorialNewsDetail ? (
                        <>
                            <section className="announcement-details-section memorial-news-details-section">
                                {/* Article Header */}
                                <div className="article-header">
                                    <h2 className="article-title">{memorialNewsDetail.title}</h2>
                                    <div className="article-meta">
                                        <span className="article-date">{formatDateToYYYYMMDD(memorialNewsDetail.createdAt)}</span>
                                        <div className="article-views">
                                        <FiEye className="eye-icon" />
                                            <span>{memorialNewsDetail.readCount}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="divider"></div>

                                {/* Article Content */}
                                <div className="article-content">
                                    <div className="article-text">
                                        <p dangerouslySetInnerHTML={{ __html: memorialNewsDetail.contents }} />
                                    </div>

                                    {memorialNewsDetail.attachments && (
                                        <div className="article-image">
                                            <div className="content-image-placeholder">
                                                <img src={memorialNewsDetail.attachments} alt="announcement-image"
                                                    onError={(e) => {
                                                        e.target.src = defaultNewsImage;
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>


                                {/* Article Navigation */}
                                <div className="article-navigation">
                                    <div
                                        className={`nav-item prev-article ${!memorialNewsDetail.previous ? 'disabled' : ''}`}
                                        onClick={() => handleNavigationClick('prev')}
                                    >
                                        <div className="nav-arrow prev-arrow">
                                            <img src={arrowLeft} alt="arrow-left" />
                                        </div>
                                        <div className="nav-content">
                                            <span className="nav-label">이전글</span>
                                            <span className="nav-title">
                                                {memorialNewsDetail.previous ? memorialNewsDetail.previous.title : '이전 글이 없습니다'}
                                            </span>
                                        </div>
                                    </div>

                                    <div
                                        className={`nav-item next-article ${!memorialNewsDetail.next ? 'disabled' : ''}`}
                                        onClick={() => handleNavigationClick('next')}
                                    >
                                        <div className="nav-content">
                                            <span className="nav-label">다음글</span>
                                            <span className="nav-title">
                                                {memorialNewsDetail.next ? memorialNewsDetail.next.title : '다음 글이 없습니다'}
                                            </span>
                                        </div>
                                        <div className="nav-arrow next-arrow">
                                            <img src={arrowRight} alt="arrow-right" />
                                        </div>
                                    </div>
                                </div>

                                {/* List Button */}
                                <div className="list-button-container">
                                    <button
                                        className="list-button"
                                        onClick={() => navigate('/memorial-news')}
                                    >
                                        목록
                                    </button>
                                </div>
                            </section>


                        </>
                    ) : null}

                </main>
            </div>
        </>
    );
};

export default MemorialNewsDetails;